import folderService from '../api/folder'

const state = {
    folder: null,
    folders: [],
}

const getters = {

}

const actions = {
    getFolders({commit}) {
        commit('ui/enableLoader', 'GET_FOLDERS', {root: true})
        return folderService
            .getFolders()
            .then(response => {
                const folders = response.data;
                folders.sort((a,b) => a.title.localeCompare(b.title))

                commit('setFolders', folders)
            })
            .finally(() => commit('ui/disableLoader', 'GET_FOLDERS', {root: true}));
    },

    getFolder({commit}, folderId) {
        commit('ui/enableLoader', 'GET_FOLDER', {root: true})

        return folderService
            .getFolder(folderId)
            .then(response => {
                const folder = response.data;

                commit('setFolder', folder)
                commit('title/updateTitle', folder.title, {root: true})
            })
            .finally(() => commit('ui/disableLoader', 'GET_FOLDER', {root: true}));
    }
}

const mutations = {
    setFolders(state, folders) {
        state.folders = folders
    },

    setFolder(state, folder) {
        state.folder = folder
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
